import { render, staticRenderFns } from "./price-summary.vue?vue&type=template&id=420bad44&scoped=true"
import script from "./price-summary.vue?vue&type=script&lang=ts"
export * from "./price-summary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420bad44",
  null
  
)

export default component.exports